import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';


@Component({
selector:'app-merchant-payment-preference',
templateUrl:'./merchant-payment-preference.component.html',
styleUrls:['./merchant-payment-preference.component.scss']
})
export class MerchantPaymentPreferenceComponent implements OnInit {


bookingId:any;

booking:any;


paymentType:string='';

advanceAmount:number=0;


constructor(
private route:ActivatedRoute,
private apiService:ApiServiceService,
private router:Router
){}



ngOnInit(){


this.bookingId =
this.route.snapshot.params['bookingId'];


console.log(
"BOOKING ID",
this.bookingId
);


this.loadBooking();


}



loadBooking(){

this.apiService
.getBookingById(this.bookingId)
.subscribe({

next:(res:any)=>{

console.log(
"BOOKING DETAILS",
res
);


this.booking=res.data;


},

error:(err)=>{

console.log(err);

}

});


}



savePaymentPreference(){


const paymentData={


bookingId:this.bookingId,

merchantId:this.booking.merchantId,

customer_email:this.booking.customer_email,

service_name:this.booking.service_name,

total_amount:this.booking.price,

payment_type:this.paymentType,

advance_amount:this.advanceAmount,

remaining_amount:
this.booking.price-this.advanceAmount


};


console.log(
"PAYMENT DATA",
paymentData
);



this.apiService
.createPayment(paymentData)
.subscribe({

next:(res:any)=>{


console.log(
"PAYMENT SAVED",
res
);


const goPaymentPage =
confirm(
"Payment preference saved successfully"
);

if(goPaymentPage){

this.router.navigate([
'/merchant/payments'
]);

}


},

error:(err)=>{


console.log(
err
);


alert(
"Payment save failed"
);


}


});


}


}